import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api } from "#app/http/api";
import { contract } from "#app/http/api";
import { ApiError, extractDomainError } from "#shared/infra/apiError";

export type UpdateLayoutNestingResponse = ClientInferResponseBody<
  typeof contract.ai.updateLayoutNesting,
  200
>;

export type UpdateLayoutNestingRequestBody = ClientInferRequest<
  typeof contract.ai.updateLayoutNesting
>["body"];

export const updateLayoutNesting = async (
  layoutId: string,
  body: UpdateLayoutNestingRequestBody,
): Promise<UpdateLayoutNestingResponse> => {
  const response = await api.ai.updateLayoutNesting.mutation({
    params: {
      id: layoutId,
    },
    body,
  });

  if (response.status === 200) {
    return response.body;
  }

  const domainError = extractDomainError(response.body);
  if (domainError) {
    throw domainError;
  }

  throw new ApiError("Failed to update layout nesting", response.status, response.body);
};
